const PHRASE = [
  "DEEN OVER DUNYA",
  "DROP 001",
  "BEFORE THE MOVEMENT, THERE WAS FAITH",
  "THE ORIGIN COLLECTION",
];

export const Marquee = () => {
  const items = [...PHRASE, ...PHRASE];
  return (
    <section
      data-testid="marquee-section"
      className="relative py-6 sm:py-8 border-y border-[#e3e2dc] bg-[#f3f2ec] overflow-hidden"
    >
      <div className="marquee-track">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center shrink-0">
            {items.map((t, i) => (
              <div key={`${dup}-${i}`} className="flex items-center">
                <span className="font-display font-extrabold uppercase text-2xl sm:text-4xl tracking-tight text-[#0a0a0b] px-6 sm:px-9">
                  {t}
                </span>
                <span className="diamond mx-1" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
